/**
 * An enum of API parameter validation error messages
 */
export enum ApiParamError {
    GENERIC_VALIDATOR_MAP_ERROR = 'There is an error in validating the API parameters using the validator map.',
    GENERIC_INVALID_PARAM_INTEGER = 'Invalid parameter, must be an integer number',
    GENERIC_INVALID_PARAM_STRING_DATE_ISO = 'Invalid parameter, must be a ISO 8601 date time string',
    GENERIC_INVALID_PARAM_STRING_UUID = 'Invalid parameter, must be a UUID string',
    GENERIC_INVALID_PARAM = 'Invalid parameter',
    GENERIC_MISSING_PARAM = 'Missing parameter',
    GENERIC_MISSING_VALIDATOR = 'Missing validator for',
    INVALID_ASSIGNMENT_ID = 'Invalid `assignment ID` parameter, must be a UUID string',
    INVALID_ASSIGNMENT_STATUS = 'Invalid `assignment status` parameter',
    INVALID_CLIENT_ID = 'Invalid `client ID` parameter, must be a UUID string',
    INVALID_DELIVERY_WINDOW = 'Invalid delivery window(s)',
    INVALID_DRIVER_ID = 'Invalid `driver ID` parameter, must be a UUID string',
    INVALID_PICKUP_WINDOW = 'Invalid pickup window(s)',
    INVALID_SELECTED_DATE = 'Invalid `selected date` parameter, must be a ISO 8601 date-time string',
    INVALID_TIMESTAMP = 'Invalid `timestamp` parameter, must be a ISO 8601 date-time string',
    MISSING_ASSIGNMENT_ID = 'Missing `assignment ID` parameter',
    MISSING_ASSIGNMENT_STATUS = 'Missing `assignment status` parameter',
    MISSING_CLIENT_ID = 'Missing `client ID` parameter',
    MISSING_DRIVER_ID = 'Missing `driver ID` parameter',
    MISSING_FILE = 'Missing file',
    MISSING_SELECTED_DATE = 'Missing `selected date` parameter',
    MISSING_TIMESTAMP = 'Missing `timestamp` parameter'
}
